import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { KONTAKT_FORM_HASH } from '../constants/navigation';

/**
 * Pri promeni rute skroluje na vrh, osim kada je hash #kontakt-form — tada skroluje do forme.
 * Ako je klik na istu stranicu iz menija, skroluje na vrh.
 */
export default function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash === `#${KONTAKT_FORM_HASH}`) {
      const t = window.setTimeout(() => {
        const el = document.getElementById(KONTAKT_FORM_HASH);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 50);
      return () => clearTimeout(t);
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [location.pathname, location.hash]);

  return null;
}
